import React from 'react';
import './style.css';
import parkingImage from '../../assets/Parking.jpeg';

export function Church() {
    return (
        <div id="church-screen">
            <div className="church-container">
                <div className="church-header-container">
                    <div className="church-header-content">AN DER KIRCHE</div>
                </div>
                <div className="church-content-container">
                    <div className="church-content-header">
                        <div className="church-content-header-first">
                            AN DER KIRCHE GIBT ES LEIDER NUR BEGRENZTE PARKMÖGLICHKEITEN.
                        </div>
                        {/* <div className="church-content-introduction-second">BITTE PARKT, WENN MÖGLICH, IM UMKREIS:</div> */}
                        <div className="church-content-header-second">
                            Bitte parkt, wenn möglich, im Umkreis der <u>Mirabellenstraße</u>, <u>Uhlbacher Straße</u>{' '}
                            und <u>Asangstraße</u>.
                        </div>
                    </div>

                    <div className="church-content-image-container">
                        <img alt="Parken an der Kirche" src={parkingImage} className="parking-image" />
                    </div>

                    <div className="church-content-description-container">
                        <div
                            className="church-content-description-color-container"
                            style={{ backgroundColor: 'red' }}
                        ></div>
                        <div className="church-content-description-text-container">Parken</div>
                        <div
                            className="church-content-description-color-container"
                            style={{ backgroundColor: 'blue' }}
                        ></div>
                        <div className="church-content-description-text-container">Fußweg / Abkürzung</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
